var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const MOBILE_MEDIA_QUERY = "(max-width: 991.98px)";
const STATIC_FILL_ATTRIBUTE = "data-sticky-static-fill";
const STATIC_FILL_REJECTED_ATTRIBUTE = "data-sticky-static-fill-rejected";
const STATIC_FILL_STATE_EVENT = "sticky-viewport:consumer-state-change";
const STATIC_FILL_TOLERANCE = 1;
class ProductStickyLayoutComponent extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "_scheduleSync", () => {
      if (this._syncRAF) return;
      this._syncRAF = requestAnimationFrame(() => {
        this._syncRAF = null;
        this._syncMeasurement();
      });
    });
    __publicField(this, "_scheduleEvaluation", () => {
      if (this._evaluationRAF) return;
      this._evaluationRAF = requestAnimationFrame(() => {
        this._evaluationRAF = null;
        this._evaluateMeasurement();
      });
    });
    __publicField(this, "_evaluateMeasurement", () => {
      var _a, _b, _c, _d;
      if (!this.isConnected || !((_a = this._media) == null ? void 0 : _a.isConnected) || !((_b = this._details) == null ? void 0 : _b.isConnected) || !((_c = this._detailsMeasurementTarget) == null ? void 0 : _c.isConnected) || !((_d = this._probe) == null ? void 0 : _d.isConnected)) {
        this._scheduleSync();
        return;
      }
      const targetHeight = this._probe.getBoundingClientRect().height;
      const mediaHeight = this._media.getBoundingClientRect().height;
      const detailsHeight = this._details.getBoundingClientRect().height;
      const detailsContentHeight = this._detailsMeasurementTarget.getBoundingClientRect().height;
      const viewportHeight = window.innerHeight;
      const detailsFitViewport = targetHeight > 0 && viewportHeight > 0 && detailsContentHeight <= viewportHeight + STATIC_FILL_TOLERANCE;
      if (!detailsFitViewport) {
        this._setCandidateRejected(true);
        this._setStaticState(false, false);
        return;
      }
      this._setCandidateRejected(false);
      const detailsHasNoStickyRange = this._detailsUsesFullHeight || detailsHeight >= mediaHeight - STATIC_FILL_TOLERANCE;
      this._setStaticState(true, detailsHasNoStickyRange);
    });
    this._mobileMedia = window.matchMedia(MOBILE_MEDIA_QUERY);
    this._resizeObserver = null;
    this._mutationObserver = null;
    this._syncRAF = null;
    this._evaluationRAF = null;
    this._media = null;
    this._details = null;
    this._detailsMeasurementTarget = null;
    this._probe = null;
  }
  connectedCallback() {
    this._mobileMedia.addEventListener("change", this._scheduleSync);
    window.addEventListener("resize", this._scheduleEvaluation, {
      passive: true
    });
    if (typeof MutationObserver !== "undefined") {
      this._mutationObserver = new MutationObserver(this._scheduleSync);
      this._mutationObserver.observe(this, {
        childList: true,
        subtree: false
      });
    }
    this._scheduleSync();
  }
  disconnectedCallback() {
    var _a;
    this._mobileMedia.removeEventListener("change", this._scheduleSync);
    window.removeEventListener("resize", this._scheduleEvaluation);
    (_a = this._mutationObserver) == null ? void 0 : _a.disconnect();
    this._mutationObserver = null;
    this._stopMeasurement();
  }
  _syncMeasurement() {
    const context = this.dataset.productStickyContext;
    const media = this.querySelector(
      ":scope > .product-information-media.full-height[data-sticky-fill-pair-item]"
    );
    const detailsSelector = context === "featured-product" ? ":scope > .product-information-details.featured-product[data-sticky-fill-pair-item]" : ":scope > .product-information-details:is([data-sticky-viewport-top], [data-sticky-fill-pair-item])";
    const details = this.querySelector(detailsSelector);
    const detailsMeasurementTarget = (details == null ? void 0 : details.querySelector(
      ":scope > .product-information-details-inner > .product-information-details-content"
    )) || details;
    const probe = this.querySelector(":scope > .product-static-fill-probe");
    const isSupportedContext = context === "featured-product" || context === "main-product";
    const isCandidate = isSupportedContext && !this._mobileMedia.matches && media && details && detailsMeasurementTarget && probe;
    if (!isCandidate) {
      this._stopMeasurement();
      return;
    }
    if (typeof ResizeObserver === "undefined") {
      this._stopMeasurement();
      this._setCandidateRejected(true);
      return;
    }
    if (this._resizeObserver && this._media === media && this._details === details && this._detailsMeasurementTarget === detailsMeasurementTarget && this._probe === probe) {
      this._beginProbe();
      return;
    }
    this._stopMeasurement();
    this._media = media;
    this._details = details;
    this._detailsMeasurementTarget = detailsMeasurementTarget;
    this._probe = probe;
    this._resizeObserver = new ResizeObserver(this._evaluateMeasurement);
    (/* @__PURE__ */ new Set([
      details,
      detailsMeasurementTarget,
      probe
    ])).forEach((item) => this._resizeObserver.observe(item));
    this._beginProbe();
  }
  _beginProbe() {
    if (this._probe.hidden) this._probe.hidden = false;
    this._setCandidateRejected(false);
    this._setStaticState(true, this._detailsUsesFullHeight);
  }
  get _detailsUsesFullHeight() {
    var _a;
    return ((_a = this._details) == null ? void 0 : _a.hasAttribute("data-sticky-fill-pair-item")) || false;
  }
  _setCandidateRejected(rejected) {
    if (this.hasAttribute(STATIC_FILL_REJECTED_ATTRIBUTE) === rejected) return;
    this.toggleAttribute(STATIC_FILL_REJECTED_ATTRIBUTE, rejected);
  }
  _setStaticState(mediaActive, detailsActive) {
    const mediaChanged = this._setItemStaticState(this._media, mediaActive);
    const detailsChanged = this._setItemStaticState(
      this._details,
      detailsActive
    );
    if (mediaChanged || detailsChanged) {
      window.dispatchEvent(new CustomEvent(STATIC_FILL_STATE_EVENT));
    }
  }
  _setItemStaticState(item, active) {
    if (!item || item.hasAttribute(STATIC_FILL_ATTRIBUTE) === active) {
      return false;
    }
    item.toggleAttribute(STATIC_FILL_ATTRIBUTE, active);
    return true;
  }
  _stopMeasurement() {
    var _a;
    if (this._syncRAF) cancelAnimationFrame(this._syncRAF);
    this._syncRAF = null;
    if (this._evaluationRAF) cancelAnimationFrame(this._evaluationRAF);
    this._evaluationRAF = null;
    (_a = this._resizeObserver) == null ? void 0 : _a.disconnect();
    this._resizeObserver = null;
    this._setStaticState(false, false);
    if (this._probe && !this._probe.hidden) this._probe.hidden = true;
    this._setCandidateRejected(false);
    this._media = null;
    this._details = null;
    this._detailsMeasurementTarget = null;
    this._probe = null;
  }
}
if (!customElements.get("product-sticky-layout-component")) {
  customElements.define(
    "product-sticky-layout-component",
    ProductStickyLayoutComponent
  );
}
